module.exports = __webpack_public_path__ + "static/homepage-cover-f679aba205ee88051b5de4a5a19e372f.png";